"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MFE_URLS = void 0;
const enums_1 = require("./enums");
exports.MFE_URLS = {
    [enums_1.ClientExposedUrl.WEBCOMPONENT_CASH_FINDER]: {
        APP_PREFIX: 'BHP',
        LOCAL_BACKEND_PORT: 9090,
        PATH: '/cash-finder',
        BUNDLE_PATH: '/cash-finder-pkg.js',
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_CUSTOM_GOAL]: {
        APP_PREFIX: 'CU5',
        LOCAL_BACKEND_PORT: 9060,
        PATH: '/cu5-custom-goal',
        BUNDLE_PATH: '/pkg/custom-goal-pkg.js',
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_CUSTOM_GOAL_INACTIVE]: {
        APP_PREFIX: 'CU5',
        LOCAL_BACKEND_PORT: 9060,
        PATH: '/inactive-cu5-custom-goal',
        BUNDLE_PATH: '/pkg/custom-goal-pkg.js',
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_CONFIRMATION_PAGE]: {
        APP_PREFIX: 'CP8',
        LOCAL_BACKEND_PORT: 9230,
        PATH: '',
        BUNDLE_PATH: '/confirmation-page-pkg.js',
        HOSTNAME: {
            ENG: 'cp8.webe.vanguard.com',
            TEST: 'cp8.webt.vanguard.com',
            PROD: 'cp8.web.vanguard.com',
        },
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_MY_PLAN_PAGE]: {
        APP_PREFIX: 'ZS0',
        LOCAL_BACKEND_PORT: 9180,
        PATH: '',
        BUNDLE_PATH: '/my-plan-page-pkg.js',
        HOSTNAME: {
            ENG: 'zs0.webe.vanguard.com',
            TEST: 'zs0.webt.vanguard.com',
            PROD: 'zs0.web.vanguard.com',
        },
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_EMERGENCY_SAVINGS]: {
        APP_PREFIX: 'ES7',
        LOCAL_BACKEND_PORT: 9020,
        PATH: '/es7-emergency-savings',
        BUNDLE_PATH: '/emergency-savings-pkg.js',
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_FIRST_MONTH_EXPERIENCE]: {
        APP_PREFIX: 'FIF',
        LOCAL_BACKEND_PORT: 9100,
        PATH: '/first-month-experience',
        BUNDLE_PATH: '/first-month-experience-pkg.js',
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_CASHFLOW]: {
        APP_PREFIX: 'FL0',
        LOCAL_BACKEND_PORT: 9050,
        PATH: '/cashflow',
        BUNDLE_PATH: '/pkg/cashflow-pkg.js',
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_CASHFLOW_INACTIVE]: {
        APP_PREFIX: 'FL0',
        LOCAL_BACKEND_PORT: 9050,
        PATH: '/inactive-cashflow',
        BUNDLE_PATH: '/pkg/cashflow-pkg.js',
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_FAQ]: {
        APP_PREFIX: 'FQW',
        LOCAL_BACKEND_PORT: 9080,
        PATH: '/faq',
        BUNDLE_PATH: '/da-faq-webapp-pkg.js',
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_SOCIAL_SECURITY_EXPERIENCE]: {
        APP_PREFIX: 'HUU',
        LOCAL_BACKEND_PORT: 9170,
        PATH: '/social-security-experience',
        BUNDLE_PATH: '/socialsecurity-experience-pkg.js',
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_SOCIAL_SECURITY_EXPERIENCE_INACTIVE]: {
        APP_PREFIX: 'HUU',
        LOCAL_BACKEND_PORT: 9170,
        PATH: '/inactive-social-security-experience',
        BUNDLE_PATH: '/socialsecurity-experience-pkg.js',
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_PERSONALIZED_PORTFOLIO]: {
        APP_PREFIX: 'KYE',
        LOCAL_BACKEND_PORT: 9030,
        PATH: '/personalized-portfolio',
        BUNDLE_PATH: '/personalized-portfolio-pkg.js',
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_MONEY_TO_WORK]: {
        APP_PREFIX: 'MTW',
        LOCAL_BACKEND_PORT: 9210,
        PATH: '/mtw-money-to-work',
        BUNDLE_PATH: '/money-to-work-pkg.js',
    },
    [enums_1.ClientExposedUrl.BACKEND_MONEY_TO_WORK]: {
        APP_PREFIX: 'MTW',
        LOCAL_BACKEND_PORT: 9210,
        PATH: '/mtw-money-to-work',
        BUNDLE_PATH: '/api',
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_ACTIVE_IN_ADVICE]: {
        APP_PREFIX: 'AA5',
        LOCAL_BACKEND_PORT: 9240,
        PATH: '/active-in-advice-webapp',
        BUNDLE_PATH: '/active-in-advice-pkg.js'
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_DAP_APPOINTMENT_SCHEDULER]: {
        APP_PREFIX: 'QKU',
        LOCAL_BACKEND_PORT: 9190,
        PATH: '/dap-appointment-scheduler',
        BUNDLE_PATH: '/dap-appointment-scheduler-pkg.js',
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_DAP_APPOINTMENT_SCHEDULER_INACTIVE]: {
        APP_PREFIX: 'QKU',
        LOCAL_BACKEND_PORT: 9190,
        PATH: '/inactive-dap-appointment-scheduler',
        BUNDLE_PATH: '/dap-appointment-scheduler-pkg.js',
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_FINANCIAL_PROFILE]: {
        APP_PREFIX: 'QYJ',
        LOCAL_BACKEND_PORT: 9110,
        PATH: '/qyj-financial-profile',
        BUNDLE_PATH: '/da-financial-profile-pkg.js',
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_FINANCIAL_PROFILE_INACTIVE]: {
        APP_PREFIX: 'QYJ',
        LOCAL_BACKEND_PORT: 9110,
        PATH: '/inactive-qyj-financial-profile',
        BUNDLE_PATH: '/da-financial-profile-pkg.js',
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_ACCOUNTS_AND_CONTRIBUTIONS]: {
        APP_PREFIX: 'YAC',
        LOCAL_BACKEND_PORT: 9070,
        PATH: '/yac-acc-contrib',
        BUNDLE_PATH: '/accounts-and-contributions-pkg.js',
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_RISKFLOW]: {
        APP_PREFIX: 'RFA',
        LOCAL_BACKEND_PORT: 9040,
        PATH: '/rfa-risk-flow',
        BUNDLE_PATH: '/risk-flow-pkg.js',
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_RISKFLOW_INACTIVE]: {
        APP_PREFIX: 'RFA',
        LOCAL_BACKEND_PORT: 9040,
        PATH: '/inactive-rfa-risk-flow',
        BUNDLE_PATH: '/risk-flow-pkg.js',
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_ACTIVE_RISK_ASSESSMENT]: {
        APP_PREFIX: 'AYM',
        LOCAL_BACKEND_PORT: 8080,
        PATH: '/aym-active-risk-assessment',
        BUNDLE_PATH: '/active-risk-assessment-mfe-pkg.js',
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_ACCOUNTS_AND_HOLDINGS]: {
        APP_PREFIX: 'GQD',
        LOCAL_BACKEND_PORT: 9130,
        PATH: '/portfolio',
        BUNDLE_PATH: '/pkg/accounts-and-holdings-pkg.js',
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_FINANCIAL_GOAL_TRADEOFFS]: {
        APP_PREFIX: 'MTQ',
        LOCAL_BACKEND_PORT: 9160,
        PATH: '/mtq-tradeoff',
        ROUTER_URL: '/goal-optimizer/dashboard',
        BUNDLE_PATH: '/financial-goal-tradeoffs-pkg.js',
    },
    [enums_1.ClientExposedUrl.FINANCIAL_GOAL_TRADEOFFS]: {
        APP_PREFIX: 'MTQ',
        LOCAL_BACKEND_PORT: 9160,
        PATH: '/mtq-tradeoff',
        ROUTER_URL: '/goal-optimizer/dashboard',
        BUNDLE_PATH: '/financial-goal-tradeoffs-pkg.js',
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_EXEMPLAR_FRONTEND]: {
        APP_PREFIX: 'MF1',
        LOCAL_BACKEND_PORT: 9000,
        PATH: '',
        BUNDLE_PATH: '/exemplar.frontend-main-pkg.js',
        HOSTNAME: {
            ENG: 'mf1.webe.vanguard.com',
            TEST: 'mf1.webt.vanguard.com',
            PROD: 'mf1.web.vanguard.com',
        },
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_SERVERLESS_MFE_EXEMPLAR]: {
        APP_PREFIX: 'MF0',
        LOCAL_BACKEND_PORT: 9270,
        PATH: '',
        BUNDLE_PATH: '/serverless-mfe-exemplar-pkg.js',
        HOSTNAME: {
            ENG: 'mf0.webe.vanguard.com',
            TEST: 'mf0.webt.vanguard.com',
            PROD: 'mf0.web.vanguard.com',
        },
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_OFFER_UPGRADE_DOWNGRADE]: {
        APP_PREFIX: 'OUD',
        LOCAL_BACKEND_PORT: 9280,
        PATH: '',
        BUNDLE_PATH: '/offer-upgrade-downgrade.frontend-main-pkg.js',
        HOSTNAME: {
            ENG: 'oud.webe.vanguard.com',
            TEST: 'oud.webt.vanguard.com',
            PROD: 'oud.web.vanguard.com',
        },
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_VMAP_POST_CONVERSION]: {
        APP_PREFIX: 'PC7',
        LOCAL_BACKEND_PORT: 9180,
        PATH: '',
        BUNDLE_PATH: '/vmap-post-conversion-pkg.js',
        HOSTNAME: {
            ENG: 'pc7.webe.vanguard.com',
            TEST: 'pc7.webt.vanguard.com',
            PROD: 'pc7.web.vanguard.com',
        },
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_PORTFOLIO_BUILDER]: {
        APP_PREFIX: 'PBJ',
        LOCAL_BACKEND_PORT: 9290,
        PATH: '',
        BUNDLE_PATH: '/portfolio-builder-pkg.js',
        HOSTNAME: {
            ENG: 'portfolio-builder.webe.vanguard.com',
            TEST: 'portfolio-builder.webt.vanguard.com',
            PROD: 'portfolio-builder.web.vanguard.com',
        },
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_ADVICE_FUTURE_TRANSACTION]: {
        APP_PREFIX: 'MAG',
        LOCAL_BACKEND_PORT: 9300,
        PATH: '',
        BUNDLE_PATH: '/advice-future-transaction.frontend-main-pkg.js',
        HOSTNAME: {
            ENG: 'ftw.webe.vanguard.com',
            TEST: 'ftw.webt.vanguard.com',
            PROD: 'ftw.web.vanguard.com',
        },
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_DAP_PLAN_ADHERENCE]: {
        APP_PREFIX: 'YPA',
        LOCAL_BACKEND_PORT: 9310,
        PATH: '',
        BUNDLE_PATH: '/dap-plan-adherence-pkg.js',
        HOSTNAME: {
            ENG: 'ypa.webe.vanguard.com',
            TEST: 'ypa.webt.vanguard.com',
            PROD: 'ypa.web.vanguard.com',
        },
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_DAP_INCOMES]: {
        APP_PREFIX: 'ERN',
        LOCAL_BACKEND_PORT: 9330,
        PATH: '',
        BUNDLE_PATH: '/dap-incomes-pkg.js',
        HOSTNAME: {
            ENG: 'ern.webe.vanguard.com',
            TEST: 'ern.webt.vanguard.com',
            PROD: 'ern.web.vanguard.com',
        },
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_ACCOUNT_CONTRIBUTIONS]: {
        APP_PREFIX: 'YAK',
        LOCAL_BACKEND_PORT: 9350,
        PATH: '',
        BUNDLE_PATH: '/account-contributions-pkg.js',
        HOSTNAME: {
            ENG: 'yak.webe.vanguard.com',
            TEST: 'yak.webt.vanguard.com',
            PROD: 'yak.web.vanguard.com',
        },
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_HOUSEHOLD_MANAGEMENT]: {
        APP_PREFIX: 'LUV',
        LOCAL_BACKEND_PORT: 9090,
        PATH: '',
        BUNDLE_PATH: '/household-management-pkg.js',
        HOSTNAME: {
            ENG: 'luv.webe.vanguard.com',
            TEST: 'luv.webt.vanguard.com',
            PROD: 'luv.web.vanguard.com',
        },
    },
    [enums_1.ClientExposedUrl.WEBCOMPONENT_ACCOUNTS_DATA_AGGREGATION]: {
        APP_PREFIX: 'DIY',
        LOCAL_BACKEND_PORT: 9360,
        PATH: '',
        BUNDLE_PATH: '/account-data-aggregation-pkg.js',
        HOSTNAME: {
            ENG: 'diy.webe.vanguard.com',
            TEST: 'diy.webt.vanguard.com',
            PROD: 'diy.web.vanguard.com',
        },
    },
};
